var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "main",
    },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          [
            _c("h2", [_vm._v(_vm._s(_vm.info.name || "--"))]),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("span", [_vm._v("注册日期：")]),
                  _vm.info.estiblishTime
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.info.estiblishTime.slice(0, 10))),
                      ])
                    : _c("span", [_vm._v("--")]),
                ]),
                _c("el-col", { attrs: { span: 16 } }, [
                  _c("span", [_vm._v("注册资本：")]),
                  _c("span", [_vm._v(_vm._s(_vm.info.regCapital || "--"))]),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "mt-15" },
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("span", [_vm._v("工商注册号：")]),
                  _c("span", [_vm._v(_vm._s(_vm.info.regNumber || "--"))]),
                ]),
                _c("el-col", { attrs: { span: 16 } }, [
                  _c("span", [_vm._v("人员规模：")]),
                  _c("span", [_vm._v(_vm._s(_vm.info.staffNumRange || "--"))]),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "mt-15" },
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("span", [_vm._v("行业：")]),
                  _c("span", { attrs: { title: _vm.info.industry } }, [
                    _vm._v(_vm._s(_vm.info.industry || "--")),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 16 } }, [
                  _c("span", [_vm._v("地址：")]),
                  _c("span", [_vm._v(_vm._s(_vm.info.regLocation || "--"))]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "tab" }, [
        _c(
          "a",
          {
            staticClass: "btn",
            class: _vm.tab === 1 ? "is-select" : "",
            on: {
              click: function ($event) {
                _vm.tab = 1
              },
            },
          },
          [_vm._v("公司背景")]
        ),
        _c(
          "a",
          {
            staticClass: "btn",
            class: _vm.tab === 2 ? "is-select" : "",
            on: {
              click: function ($event) {
                _vm.tab = 2
              },
            },
          },
          [_vm._v("经营信息")]
        ),
        _c(
          "a",
          {
            staticClass: "btn",
            class: _vm.tab === 3 ? "is-select" : "",
            on: {
              click: function ($event) {
                _vm.tab = 3
              },
            },
          },
          [_vm._v("知识产权")]
        ),
        _c(
          "a",
          {
            staticClass: "btn",
            class: _vm.tab === 4 ? "is-select" : "",
            on: {
              click: function ($event) {
                _vm.tab = 4
              },
            },
          },
          [_vm._v("关系图谱")]
        ),
      ]),
      _vm.tab === 1
        ? _c(
            "div",
            { staticClass: "content" },
            [_c("company", { attrs: { info: _vm.info } })],
            1
          )
        : _vm._e(),
      _vm.tab === 2
        ? _c("div", { staticClass: "content" }, [_c("manage")], 1)
        : _vm._e(),
      _vm.tab === 3
        ? _c("div", { staticClass: "content" }, [_c("intellectual")], 1)
        : _vm._e(),
      _vm.tab === 4
        ? _c(
            "div",
            { staticClass: "content" },
            [_c("relation", { attrs: { info: _vm.info } })],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }